import { svg } from 'lit';

/**
 * ✅
 */
export const ConfirmIcon = svg`<svg
   width="20"
   height="20"
   viewBox="0 0 20 20"
   xmlns="http://www.w3.org/2000/svg"
 >
   <path
     fill-rule="evenodd"
     clip-rule="evenodd"
     d="M17.6726 6.0059L7.49998 16.1785L2.32739 11.0059L3.5059 9.82739L7.49998 13.8215L16.4941 4.82739L17.6726 6.0059Z"
   />
 </svg>`;

/**
 * @deprecated Not used now.
 */
export const CopyIcon = svg`<svg
   width="20"
   height="20"
   viewBox="0 0 20 20"
   xmlns="http://www.w3.org/2000/svg"
 >
   <path
     fill-rule="evenodd"
     clip-rule="evenodd"
     d="M9.72206 2.6665C9.18226 2.6665 8.66128 2.87542 8.27457 3.25246C7.88728 3.63007 7.6665 4.14585 7.6665 4.68734V5.1665H4.72206C4.16827 5.1665 3.64271 5.39554 3.25941 5.79417C2.87697 6.1919 2.6665 6.72597 2.6665 7.27762V15.2221C2.6665 15.7737 2.87697 16.3078 3.25941 16.7055C3.64271 17.1041 4.16827 17.3332 4.72206 17.3332H10.2776C10.8314 17.3332 11.357 17.1041 11.7403 16.7055C12.1227 16.3078 12.3332 15.7737 12.3332 15.2221V14.8332H15.2776C15.8174 14.8332 16.3384 14.6243 16.7251 14.2472C17.1124 13.8696 17.3332 13.3538 17.3332 12.8123V6.88236C17.3331 6.61073 17.2774 6.34228 17.1697 6.09292C17.0621 5.84367 16.9049 5.61891 16.7084 5.43161L14.4064 3.23658C14.0213 2.86942 13.5074 2.66657 12.9755 2.6665H9.72206ZM10.9998 14.8332V15.2221C10.9998 15.4366 10.9176 15.6373 10.7792 15.7814C10.6415 15.9245 10.4605 15.9998 10.2776 15.9998H4.72206C4.53914 15.9998 4.35816 15.9245 4.22052 15.7814C4.08203 15.6373 3.99984 15.4366 3.99984 15.2221V7.27762C3.99984 7.06308 4.08203 6.86235 4.22052 6.71831C4.35816 6.57517 4.53914 6.49984 4.72206 6.49984H7.6665V12.8123C7.6665 13.3538 7.88728 13.8696 8.27457 14.2472C8.66128 14.6243 9.18226 14.8332 9.72206 14.8332H10.9998ZM8.99984 5.83317V12.8123C8.99984 12.9891 9.07172 13.1622 9.20537 13.2925C9.33959 13.4234 9.52515 13.4998 9.72206 13.4998H11.6665H15.2776C15.4745 13.4998 15.6601 13.4234 15.7943 13.2925C15.928 13.1622 15.9998 12.9891 15.9998 12.8123V6.88252C15.9998 6.79338 15.9816 6.70462 15.9456 6.62146C15.9097 6.53823 15.8566 6.46169 15.7885 6.39682L13.4863 4.20163C13.3526 4.0741 13.1695 3.99988 12.9755 3.99984H9.72206C9.52514 3.99984 9.33959 4.07626 9.20537 4.20713C9.07172 4.33744 8.99984 4.51053 8.99984 4.68734V5.83317Z"
   />
 </svg>`;

/**
 * 🖊️
 */
export const EditIcon = svg`<svg
   width="20"
   height="20"
   viewBox="0 0 20 20"
   xmlns="http://www.w3.org/2000/svg"
 >
   <path
     fill-rule="evenodd"
     clip-rule="evenodd"
     d="M5.332 13.2203L5.01238 14.1792L5.82087 14.9877L6.77971 14.668L13.6405 7.80725L12.1928 6.35954L5.332 13.2203ZM13.1356 5.41673L14.5833 6.86444L15.7238 5.72395C16.1236 5.32417 16.1236 4.67601 15.7238 4.27623C15.324 3.87646 14.6759 3.87646 14.2761 4.27623L13.1356 5.41673ZM13.3333 3.33342L4.27791 12.3888C4.20472 12.462 4.14958 12.5512 4.11686 12.6494L2.92159 16.2352C2.74787 16.7563 3.2437 17.2522 3.76487 17.0785L7.35065 15.8832C7.44884 15.8505 7.53806 15.7953 7.61124 15.7221L16.6666 6.66676C17.5871 5.74628 17.5871 4.2539 16.6666 3.33342C15.7461 2.41295 14.2538 2.41295 13.3333 3.33342Z"
   />
 </svg>`;

export const CashBinIcon = svg`<svg
   width="20"
   height="20"
   viewBox="0 0 20 20"
   xmlns="http://www.w3.org/2000/svg"
 >
   <path
     fill-rule="evenodd"
     clip-rule="evenodd"
     d="M18.3332 5.83333H1.6665V4.5H18.3332V5.83333Z"
   />
   <path
     fill-rule="evenodd"
     clip-rule="evenodd"
     d="M6.66683 1.66667L13.3335 1.66667L13.3335 3L6.66683 3L6.66683 1.66667Z"
   />
   <path
     fill-rule="evenodd"
     clip-rule="evenodd"
     d="M4.66683 5.8335V15.8335C4.66683 16.4778 5.18916 17.0002 5.83349 17.0002H14.1668C14.8112 17.0002 15.3335 16.4778 15.3335 15.8335V5.8335H16.6668V15.8335C16.6668 17.2142 15.5475 18.3335 14.1668 18.3335H5.83349C4.45278 18.3335 3.3335 17.2142 3.3335 15.8335V5.8335H4.66683Z"
   />
   <path
     fill-rule="evenodd"
     clip-rule="evenodd"
     d="M7.50016 15L7.50016 7.5L8.8335 7.5L8.8335 15L7.50016 15Z"
   />
   <path
     fill-rule="evenodd"
     clip-rule="evenodd"
     d="M12.4998 7.5L12.4998 15L11.1665 15L11.1665 7.5L12.4998 7.5Z"
   />
 </svg>`;

export const UnlinkIcon = svg`<svg
 width="20"
 height="20"
 viewBox="0 0 20 20"
 xmlns="http://www.w3.org/2000/svg"
>
 <path
   fill-rule="evenodd"
   clip-rule="evenodd"
   d="M14.3544 11.3678L16.5109 9.2113C17.9754 7.74683 17.9754 5.37246 16.5109 3.908L16.085 3.48214C14.6206 2.01767 12.2462 2.01767 10.7817 3.48214L8.06422 6.19966C6.59975 7.66413 6.59975 10.0385 8.06422 11.503L8.49008 11.9288C8.75643 12.1952 9.05289 12.4131 9.3685 12.5826L10.042 11.909C10.1513 11.7997 10.2324 11.6729 10.2852 11.5376C9.97446 11.4201 9.68307 11.2362 9.43289 10.986L9.00703 10.5602C8.06326 9.61639 8.06326 8.08624 9.00703 7.14247L11.7246 4.42495C12.6683 3.48118 14.1985 3.48118 15.1422 4.42495L15.5681 4.85081C16.5119 5.79457 16.5119 7.32472 15.5681 8.26849L14.1479 9.6887C14.3104 10.2349 14.3792 10.803 14.3544 11.3678ZM5.63767 8.62376L3.48116 10.7803C2.0167 12.2447 2.0167 14.6191 3.48116 16.0836L3.90702 16.5094C5.37149 17.9739 7.74586 17.9739 9.21032 16.5094L11.9278 13.7919C13.3923 12.3274 13.3923 9.95307 11.9278 8.48861L11.502 8.06275C11.2356 7.79639 10.9392 7.57848 10.6236 7.40901L9.95003 8.08255C9.84074 8.19184 9.75969 8.31867 9.70686 8.45398C10.0176 8.57152 10.309 8.75538 10.5592 9.00556L10.985 9.43142C11.9288 10.3752 11.9288 11.9053 10.985 12.8491L8.26752 15.5666C7.32375 16.5104 5.7936 16.5104 4.84983 15.5666L4.42397 15.1408C3.4802 14.197 3.4802 12.6668 4.42397 11.7231L5.84418 10.3029C5.68166 9.75667 5.61282 9.18854 5.63767 8.62376ZM12.78 14.3772C12.9325 14.2416 13.1295 14.1666 13.3336 14.1666C13.5547 14.1666 13.7666 14.2544 13.9229 14.4107C14.0792 14.567 14.167 14.7789 14.167 15V16.6666L14.1611 16.7641C14.1361 16.975 14.0314 17.1684 13.8685 17.3047C13.7056 17.4411 13.4968 17.51 13.2848 17.4976C13.0728 17.4852 12.8735 17.3922 12.7277 17.2378C12.5819 17.0833 12.5005 16.879 12.5003 16.6666V15L12.5061 14.9025C12.53 14.6997 12.6275 14.5129 12.78 14.3772ZM15.2625 12.7273C15.417 12.5815 15.6212 12.5002 15.8336 12.5H16.667L16.7645 12.5058C16.9754 12.5309 17.1688 12.6356 17.3051 12.7984C17.4414 12.9613 17.5104 13.1701 17.498 13.3821C17.4855 13.5942 17.3926 13.7934 17.2381 13.9392C17.0837 14.0851 16.8794 14.1664 16.667 14.1666H15.8336L15.7361 14.1608C15.5252 14.1357 15.3319 14.031 15.1955 13.8681C15.0592 13.7053 14.9902 13.4965 15.0027 13.2845C15.0151 13.0724 15.1081 12.8731 15.2625 12.7273ZM2.74439 6.07737C2.90067 5.92109 3.11263 5.83329 3.33365 5.83329H4.16698C4.38799 5.83329 4.59995 5.92109 4.75623 6.07737C4.91252 6.23365 5.00031 6.44561 5.00031 6.66662C5.00031 6.88764 4.91252 7.0996 4.75623 7.25588C4.59995 7.41216 4.38799 7.49996 4.16698 7.49996H3.33365C3.11263 7.49996 2.90067 7.41216 2.74439 7.25588C2.58811 7.0996 2.50031 6.88764 2.50031 6.66662C2.50031 6.44561 2.58811 6.23365 2.74439 6.07737ZM6.11334 2.71055C6.26587 2.57492 6.46287 2.49998 6.66698 2.49996C6.88799 2.49996 7.09995 2.58775 7.25623 2.74403C7.41251 2.90031 7.50031 3.11228 7.50031 3.33329V4.99996L7.49448 5.09746C7.46939 5.30837 7.36472 5.50174 7.20184 5.63807C7.03896 5.77439 6.83018 5.84338 6.61814 5.83093C6.40611 5.81849 6.20683 5.72554 6.06102 5.5711C5.91521 5.41665 5.83388 5.21236 5.83365 4.99996V3.33329L5.83948 3.23579C5.86336 3.03308 5.96081 2.84619 6.11334 2.71055Z"
 />
</svg>`;
